import { locales, useLocaleContext } from './locale-environment'
import { createTranslationsEnvironment } from './Translations'

export const { useTranslations, createTranslations } =
  createTranslationsEnvironment({
    locales,
    useLocale: () => useLocaleContext().locale,
  })
